// Fetches stations from the nginx-served static files.
//
// Two-step protocol to let nginx cache aggressively:
//   1. GET /data/manifest.json  (no-cache → always fresh)
//   2. GET /data/stations.<hash>.json  (max-age immutable → cache forever)
//
// The .json.gz next to the hashed file is served by gzip_static when
// the browser sends Accept-Encoding: gzip. No client-side action needed.

import type { Manifest, Station, StationsPayload } from "./types";

// BASE_URL is "/" for embed/widget builds and "/paliwo/" / "/fuel/" / "/sprit/"
// / "/carburant/" for fullweb variants. Prefixing here makes data fetches
// scoped under the variant path, so each parent portal's nginx only needs
// to proxy a single prefix (e.g. wyspykanaryjskie.info/paliwo/* → us) without
// extra `/data/*` proxy rules polluting the main-domain namespace.
const DATA_BASE = `${import.meta.env.BASE_URL}data`;

export async function loadStations(): Promise<Station[]> {
  const manifest = await fetchJson<Manifest>(`${DATA_BASE}/manifest.json`, {
    cache: "no-cache",
  });
  const payload = await fetchJson<StationsPayload>(
    `${DATA_BASE}/${manifest.current}`,
  );
  return payload.stations;
}

async function fetchJson<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, init);
  if (!response.ok) {
    throw new Error(`Failed to fetch ${url}: ${response.status}`);
  }
  return (await response.json()) as T;
}
